import { render, staticRenderFns } from "./Kamar.vue?vue&type=template&id=2cfa9867&"
import script from "./Kamar.vue?vue&type=script&lang=js&"
export * from "./Kamar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports